import opentype from 'opentype.js';
import { isNullOrUndefined } from '@deltasierra/type-utilities';
import { TextToFallbackFontLink } from '../builderDocument/builderDocumentRendering';
import { stripLetterSpacingCharacters } from '../graphics';

export const FALLBACK_FONTS: { [key: string]: string } = {
    'NotoSansJP-Regular': 'NotoSansJP-Regular.otf',
    'NotoSansKR-Regular': 'NotoSansKR-Regular.otf',
    'NotoSansSC-Regular': 'NotoSansSC-Regular.otf',
    'NotoSansTC-Regular': 'NotoSansTC-Regular.otf',
};

/**
 * Function checks whether a font file contains all glyphs required to render a string of text.
 *
 * @param fontFamily - name of font
 * @param fontBuffer - font file read as an ArrayBuffer
 * @param text - text to check
 * @returns - True if font can render all characters in text, else False.
 * Also returns False if font file is not supported by opentype.js and can't be read.
 */
export function checkFontContainsCharacters(fontFamily: string, fontBuffer: ArrayBuffer, text: string): boolean {
    const font = opentype.parse(fontBuffer);
    if (!font.supported) {
        // eslint-disable-next-line no-console
        console.log(`Loaded font ${fontFamily} is not supported and can't be checked.`);
        return false;
    }
    const substitutedText = stripLetterSpacingCharacters(text);
    // Newline character sometimes returned as undefined when checking against some font files. We don't want this.
    const textWithoutWhitespaces = substitutedText.replace(/\s+/g, '');
    for (const char of textWithoutWhitespaces.split('')) {
        const glyph = font.charToGlyph(char);
        // Typing seems wrong, 'unicode' property can be undefined.
        if (isNullOrUndefined(glyph.unicode)) {
            return false;
        }
    }
    return true;
}

export function getFallbackFont(
    text: string,
    selectedFont: string,
    textToFallbackFontLink: TextToFallbackFontLink[] = [],
): string | undefined {
    for (const link of textToFallbackFontLink) {
        if (link.text === text && link.selectedFont === selectedFont) {
            return link.fallbackFont;
        }
    }
    return undefined;
}
